import IntlMessageFormat from 'intl-messageformat';
import _format from 'date-fns/format';

export const CURRENCY = __('formatting.currencyIso') || 'EUR';

export const LOCALE = __LOCALE__;
export const LANGUAGE = __LANGUAGE__;

export const CURRENCY_SYMBOLS = {
  EUR: '€',
  PLN: 'zł',
  DKK: 'kr',
  SEK: 'kr',
};

const stringFormatter = (message) =>
  new IntlMessageFormat(message, LOCALE).format;

const formatMarkdown = (message) => {
  return message.replace(/\*\*([a-zA-Z0-9\s]+)\*\*/, '<strong>$1</strong>');
};

const numberFormat = new Intl.NumberFormat(LOCALE, {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
  style: 'decimal',
});

const moneyFormat = new Intl.NumberFormat(LANGUAGE, {
  currency: CURRENCY,
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
  style: 'currency',
});

const fuelConsumptionFormat = new Intl.NumberFormat(LOCALE, {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
  style: 'decimal',
});

const formatters = {
  distanceKm: stringFormatter(__('distance.km')),
  powerHp: stringFormatter(__('power.hp')),
  powerKw: stringFormatter(__('power.kw')),
};

const formatNumber = numberFormat.format;
const formatMoney = moneyFormat.format;
const formatFuelConsumption = fuelConsumptionFormat.format;

const formatPower = ({ hp, kw }) => {
  if (hp !== undefined) {
    hp = formatters.powerHp({ power: formatNumber(hp) });
  }

  if (kw !== undefined) {
    kw = formatters.powerKw({ power: formatNumber(kw) });
  }

  if (kw && hp) {
    return `${kw} (${hp})`;
  } else if (kw) {
    return kw;
  } else if (hp) {
    return hp;
  }
};

const formatDistance = (num) =>
  formatters.distanceKm({ distance: formatNumber(num) });

const getMonthsForLocale = () => {
  const format = new Intl.DateTimeFormat(LOCALE, { month: 'long' });
  const months = [];
  const monthCount = 12;
  const baseYear = 2000;

  for (let month = 0; month < monthCount; month += 1) {
    const testDate = new Date(Date.UTC(baseYear, month, 1, 0, 0, 0));

    months.push(format.format(testDate));
  }

  return months;
};

function formatMoneyWithOptions(options = {}) {
  const opts = {
    currency: CURRENCY,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    ...options,
    style: 'currency',
  };

  return new Intl.NumberFormat(LOCALE, opts).format;
}

function getCurrencySymbol(currency = CURRENCY) {
  return CURRENCY_SYMBOLS[currency];
}

function formatDate(date, formatStr) {
  return _format(date, formatStr, {
    locale: require('date-fns/locale/' + __LANGUAGE__),
  });
}

function formatMoneyFixed(value) {
  return `${numberFormat.format(value)} ${getCurrencySymbol()}`;
}

export {
  formatDistance,
  formatFuelConsumption,
  formatMarkdown,
  formatMoney,
  formatNumber,
  formatPower,
  stringFormatter,
  getMonthsForLocale,
  getCurrencySymbol,
  formatMoneyWithOptions,
  formatDate,
  formatMoneyFixed,
};
